import React from 'react';
import styled from '@emotion/styled';
import { Tile } from './Tile';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { WaitTimeCategory } from '../../domain/models/WaitTimeCategory';

interface ICheckpointQueueWaitTimesProps {
	waitTime: string;
	category: WaitTimeCategory;
}

export const CheckpointQueueWaitTimes = ({
	waitTime,
	category,
}: ICheckpointQueueWaitTimesProps) => {
	const { t } = useTranslation();

	return (
		<Tile variant={category}>
			<WaitTime>{waitTime}</WaitTime>
			<Unit>{t('security_checkpoint_wait_time_unit')}</Unit>
		</Tile>
	);
};

const WaitTime = styled.h3`
	color: inherit;
	margin-bottom: 0;
	line-height: 1;
`;

const Unit = styled.div`
	font-weight: normal;
`;
